import { render, staticRenderFns } from "./EvaluationBooking.vue?vue&type=template&id=2f277e4c&scoped=true&"
import script from "./EvaluationBooking.vue?vue&type=script&lang=js&"
export * from "./EvaluationBooking.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationBooking.vue?vue&type=style&index=0&id=2f277e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f277e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
